module.exports = {"translations":{"section-student-check-title":"Er du studerende?","step-student-check-submit-button-text":"Beregn din pris","step-ownership-submit-button-text":"Næste","section-student-check-name":"Dig","step-price-student-discount-text":"Som studerende får du særlig gode priser hos TJM Forsikring"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/content/cu/package.content-tjm-student-text.json
// module id = 715
// module chunks = 0